import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BuildIcon from '@mui/icons-material/Build';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FlagIcon from '@mui/icons-material/Flag';
import StarsIcon from '@mui/icons-material/Stars';

const hoverStyle = {
  transition: 'transform 0.4s ease, box-shadow 0.4s ease',
  transformStyle: 'preserve-3d',
  '&:hover': {
    transform: 'rotateY(10deg) rotateX(5deg) translateZ(15px)',
    boxShadow: '0 20px 30px rgba(0,0,0,0.3)',
    cursor: 'pointer',
  },
};

const AboutDes = () => {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{  minHeight: '100vh' }}>
      {/* Hero */}
      <Box sx={{ py: { xs: 8, md: 12 }, px: 3,  color: '#0057A4', textAlign: 'center', mt: { xs: 8, md: 12 } }}>
        <Container maxWidth="md">
          <Typography variant="h3" fontWeight="bold" gutterBottom>{t("about.title")}</Typography>
          <Typography variant="h6" color="text.primary" sx={{ fontWeight: 500 }}>{t("about.subtitle")}</Typography>
        </Container>
      </Box>

      {/* Legacy */}
      <Box sx={{ py: { xs: 6, md: 10 }, }}>
        <Container maxWidth="lg" sx={{ perspective: '1200px' }}>
          <Grid container spacing={6} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Paper elevation={4} sx={{
                p: 4,
                borderTop: `10px solid #CE8238`,
                borderLeft: `10px solid #0057A4`,
                borderRadius: 10,
                backgroundColor: '#fff',
                height: '100%',
                ...hoverStyle,
              }}>
                <Typography variant="h4" fontWeight="bold" color="#CE8238" mb={3} display="flex" alignItems="center" gap={1}>
                  <AccountBalanceIcon fontSize="large" /> {t("about.legacy.title")}
                </Typography>
                <Typography color="text.secondary" mb={2} sx={{ fontSize: '1.1rem' }}>
                  {t("about.legacy.description")}
                </Typography>
                <Box component="ul" sx={{ pl: 3, color: '#333', fontSize: '1rem', mb: 0 }}>
                  {t("about.legacy.projects", { returnObjects: true }).map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Ongoing Projects */}
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#0057A4', color: '#fff' ,marginTop:"11px"}}>
        <Container maxWidth="lg" sx={{ perspective: '1200px' }}>
          <Grid container spacing={6} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Paper elevation={4} sx={{
                p: 4,
                borderRadius: 3,
                backgroundColor: '#0057A4',
                color: '#fff',
                height: '100%',
                ...hoverStyle,
              }}>
                <Typography variant="h4" fontWeight="bold" mb={3} display="flex" alignItems="center" gap={1}>
                  <BuildIcon fontSize="large" /> {t("about.ongoing.title")}
                </Typography>
                <Typography sx={{ fontSize: '1.1rem', lineHeight: 1.6 }}>
                  {t("about.ongoing.desc1")}
                </Typography>
                <Typography sx={{ mt: 2, fontSize: '1.1rem', lineHeight: 1.6 }}>
                  {t("about.ongoing.desc2")}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Vision */}
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#fff' }}>
        <Container maxWidth="md" textAlign="center">
          <VisibilityIcon sx={{ fontSize: 48, color: '#CE8238', mb: 2 }} />
          <Typography variant="h4" fontWeight="bold" color="#CE8238" mb={3}>{t("about.vision.title")}</Typography>
          <Typography color="text.secondary" sx={{ fontSize: '1.2rem', maxWidth: 600, mx: 'auto', lineHeight: 1.6 }}>
            {t("about.vision.desc")}
          </Typography>
        </Container>
      </Box>

      {/* Mission */}
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#f0f2f5' }}>
        <Container maxWidth="md" textAlign="center">
          <FlagIcon sx={{ fontSize: 48, color: '#0057A4', mb: 2 }} />
          <Typography variant="h4" fontWeight="bold" color="#0057A4" mb={3}>{t("about.mission.title")}</Typography>
          <Typography color="text.secondary" sx={{ fontSize: '1.2rem', maxWidth: 600, mx: 'auto', lineHeight: 1.6 }}>
            {t("about.mission.desc")}
          </Typography>
        </Container>
      </Box>

      {/* Core Values */}
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#CE8238', color: '#fff' }}>
        <Container maxWidth="md" textAlign="center">
          <StarsIcon sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h4" fontWeight="bold" mb={3}>
            {t("about.values.title")}
          </Typography>
          <Typography sx={{ fontSize: '1.15rem', maxWidth: 600, mx: 'auto', lineHeight: 1.6 }}>
            {t("about.values.desc")}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default AboutDes;
